import React from 'react';

import { PharmacistSignature as BasePharmacistSignature } from './pharmacistSignature';
import { usePatientDetailsContext } from './patientDetails';
import { shouldHideDriverPharmacistSignature } from '../../utils/helper/pharmacistSignatureVisibility';

export const DriverPharmacistSignature = ({ patientData, rxData, ...props }) => {
	const patientDetailsContext = usePatientDetailsContext();
	const shouldHide = shouldHideDriverPharmacistSignature({
		patientData: patientData ?? patientDetailsContext?.patientData,
		rxData,
	});

	if (shouldHide) return null;

	return <BasePharmacistSignature {...props} />;
};

